module.exports = __webpack_public_path__ + "static/media/banner.6a3a880e.mp4";